<template>
  <div class="anon-leads-index">
    <Breadcrumbs
      :breadcrumbs="[
      {title: this.$t('menu.audiology'), disabled: true},
      {title: this.$t('menu.anonleads'), disabled: true}
    ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <!--<Searchable class="mr-2" :querySearch.sync="querySearch" />-->
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters"/>
      </div>
    </Breadcrumbs>

    <AnonLeadsTable
      v-if="entities !== null"
      ref="anonLeadsTable"
      :entities="entities"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      :customQueries="customQueries"
      @filters-updated="onFiltersUpdated"
      @editLead="handleEditLead"/>

    <AnonLeadEditModal
      v-if="showEditModal"
      :editingLead="editingLead"
      @canceled="handleEditCancel"
      @saved="handleEditSaved"
    />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs'
import Searchable from '@/components/common/Searchable'
import Filters from '@/components/common/Filters'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import { TABLE_ANON_LEADS } from '@/local-storage/LocalStorageKeys'
import AnonLeadsTable from '@/components/anonleads/AnonLeadsTable'
import AnonLeadEditModal from '@/components/anonleads/AnonLeadEditModal'
import { LeadsService } from '@/api/LeadsService'
export default {
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  components: { AnonLeadEditModal, AnonLeadsTable, Filters, Searchable, Breadcrumbs },
  mixins: [
    IndexTablesMixin
  ],
  data () {
    return {
      entities: null,
      showEditModal: false,
      editingLead: null,
      querySearch: '',
      customQueries: null,
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_ANON_LEADS,
    }
  },
  created () {
    this.loadEntities()
  },
  methods: {
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    handleEditLead: function (lead) {
      this.editingLead = lead
      this.showEditModal = true
    },
    handleEditCancel: function () {
      this.editingLead = null
      this.showEditModal = false
    },
    handleEditSaved: function () {
      this.editingLead = null
      this.showEditModal = false
      this.$refs.anonLeadsTable.reload()
    },
    loadEntities: function () {
      LeadsService.getEntities()
        // eslint-disable-next-line camelcase
        .then(({ leads_read, leads_write, leads_sale_price_read, leads_sale_price_write }) => {
          this.entities = leads_read // eslint-disable-line camelcase
          this.entitiesWrite = leads_write // eslint-disable-line camelcase
        }).catch(err => console.log(err))
    },
  },
}
</script>

<style scoped>

</style>
